import { AdPositionConfig } from '@wegoTypes/adPositionConfig';

export const getRealAdPosition = (ad: AdPositionConfig, allAds: AdPositionConfig[]): number => {
  const allAdsBeforeCurrentPosition = allAds.slice(0, allAds.indexOf(ad));

  const allSkippedAdsQuantity = allAdsBeforeCurrentPosition.filter(
    (ad) => ad.isSkip && !ad.visible,
  ).length;

  // leaderboards are not visible, but they are still having a invisible placeholder div, so we need to add them to the count so the actual displayed position is correct
  const allInvisibleLeaderboardPlaceholdersQuantity = allAdsBeforeCurrentPosition.filter(
    (ad) => !ad.visible && ad.type === 'leaderboard',
  ).length;

  return ad.index - allSkippedAdsQuantity + allInvisibleLeaderboardPlaceholdersQuantity;
};
